import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  MainContent: {
    flexGrow: 1,
    marginLeft: 'auto',
    marginRight: 'auto',
    
    background: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(56,56,70,1) 22%, rgba(87,87,117,1) 41%, rgba(94,94,125,1) 48%, rgba(92,92,125,1) 53%, rgba(67,67,83,1) 71%, rgba(36,36,57,1) 85%, rgba(0,0,0,1) 95%)',
    //overflowX: 'hidden',
  },
  image: {
    maxWidth: '100%',
  },

  MainBox: {
    marginBottom: '20%'
  },
}));